@if (isSummernoteEditor) {
    <div class="form-group" ngModelGroup="formField{{ formField.id }}">
        <sb-form-field-label [formField]="formField"></sb-form-field-label>
        @if (!formCommonDataService.isMessageContentLoaded) {
            <sb-loader></sb-loader>
        }
        @if (isWithReplyTemplates && summernote && replyTemplateService.allReplyTemplates.length) {
            <sb-quill-reply-templates
                parentContainerId="form-element-{{ formField.id }}"
                [summernote]="summernote"
                [attachments]="attachments">
            </sb-quill-reply-templates>
        }
        @if (formCommonDataService.isMessageContentLoaded) {
            <div
                ngDefaultControl
                id="form-element-{{ formField.id }}"
                class="summernote"
                name="formField{{ formField.id }}"
                [ngxSummernote]="summernoteConfig"
                [(ngModel)]="formField.value"
                (ngModelChange)="onSummernoteContentChanged()"></div>
        }

        @if (isForwardForm) {
            <!--            todo: check wht do we have separated block for forward form-->
            <div class="buttons-panel">
                <!--            <app-quill-emoji-picker-->
                <!--                *ngIf="isLocalStorageSupported"-->
                <!--                [buttonId]="'btn-emoji'"-->
                <!--                class="float-end"-->
                <!--                [containerClass]="'smiley-popover'"-->
                <!--                (updateQuillSelection)="saveSummernoteRange()"-->
                <!--                (emojiSelect)="setEmojiToSummernote($event.emoji)">-->
                <!--            </app-quill-emoji-picker>-->
                @if (isWithReplyTemplates) {
                    <button
                        (click)="openReplyTemplatesModalToSummernote()"
                        class="btn btn-icon float-end"
                        type="button"
                        [attr.aria-label]="'Reply templates' | translate"
                        tooltip="{{ 'Insert a saved template' | translate }}"
                        container="body">
                        <sb-inline-svg class="icon" [url]="'/assets/images/Copy icon.svg'"></sb-inline-svg>
                    </button>
                }

                @if (isWithSignature) {
                    <button
                        [disabled]="!isSignatureLoaded || !commonDataService.signatures?.socialBoards"
                        [attr.aria-label]="'Signature' | translate"
                        (click)="setSignatureToSummernote()"
                        class="btn btn-icon float-end"
                        id="btn-signature"
                        type="button"
                        tooltip="{{ 'Signature' | translate }}"
                        container="body">
                        <sb-inline-svg
                            class="icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Pen icon.svg'">
                        </sb-inline-svg>
                    </button>
                }
                <ng-container *ngTemplateOutlet="attachmentsBlockTemplate"></ng-container>
            </div>
            <div
                class="clearfix"
                [hidden]="
                    !(isWithReplyTemplates || isInternalForm) ||
                    (formService.isSubmitted && isQuillEmpty && formField.isRequired)
                "></div>
        }
    </div>
} @else {
    <div class="form-group ticket-message" ngModelGroup="formField{{ formField.id }}">
        @if (formField.label) {
            <label (click)="quillEditor.focus()"> {{ formField.label }}{{ formField.isRequired ? ' *' : '' }} </label>
        }
        <div class="position-relative smile-field-container">
            @if (isWithReplyTemplates && quillEditor && replyTemplateService.allReplyTemplates.length) {
                <sb-quill-reply-templates
                    parentContainerId="form-element-{{ formField.id }}"
                    [quillEditor]="quillEditor"
                    [emitAttachments]="true">
                </sb-quill-reply-templates>
            }
            <quill-editor
                id="form-element-{{ formField.id }}"
                class="quill-editor"
                name="formField{{ formField.id }}"
                (onEditorCreated)="onEditorCreated($event)"
                (onContentChanged)="onContentChanged($event)"
                [ngClass]="{
                    'ng-invalid': formField.isRequired && isQuillEmpty,
                    'without-toolbar': !isHtmlEditor,
                }"
                [trimOnValidation]="true"
                [format]="isHtmlEditor || isInternalForm ? 'html' : 'text'"
                [formats]="isHtmlEditor ? null : ['emoji']"
                [required]="formField.isRequired && isQuillEmpty"
                [(ngModel)]="formField.valueModel.htmlValue"
                [modules]="editorModules"
                [placeholder]="quillPlaceholder">
                @if (isHtmlEditor) {
                    <div quill-editor-toolbar id="toolbar-quill">
                        <button
                            class="ql-bold ql-focusable"
                            type="button"
                            tooltip="{{ 'Bold' | translate }}"
                            container="body"
                            [attr.aria-label]="'Bold' | translate"
                            tabindex="0"
                            (focus)="resetFocusedToolbarElementIndex()"></button>
                        <button
                            class="ql-italic ql-focusable"
                            type="button"
                            tooltip="{{ 'Italic' | translate }}"
                            container="body"
                            [attr.aria-label]="'Italic' | translate"
                            tabindex="-1"></button>
                        <button
                            class="ql-underline ql-focusable"
                            type="button"
                            tooltip="{{ 'Underline' | translate }}"
                            container="body"
                            [attr.aria-label]="'Underline' | translate"
                            tabindex="-1"></button>
                        <button
                            class="ql-strike ql-focusable me-3"
                            type="button"
                            tooltip="{{ 'Strikethrough' | translate }}"
                            container="body"
                            [attr.aria-label]="'Strikethrough' | translate"
                            tabindex="-1"></button>
                        <button
                            class="ql-list ql-focusable"
                            type="button"
                            tooltip="{{ 'Ordered list' | translate }}"
                            container="body"
                            value="ordered"
                            [attr.aria-label]="'Ordered list' | translate"
                            tabindex="-1"></button>
                        <button
                            class="ql-list ql-focusable me-3"
                            type="button"
                            tooltip="{{ 'Bullet list' | translate }}"
                            container="body"
                            value="bullet"
                            [attr.aria-label]="'Bullet list' | translate"
                            tabindex="-1"></button>
                        <select
                            class="ql-header ql-focusable me-3 quill-tooltip"
                            [attr.data-tooltip]="'Text size' | translate"
                            [attr.aria-label]="'Text size' | translate"
                            tabindex="-1">
                            <option selected></option>
                            <option value="1"></option>
                            <option value="2"></option>
                            <option value="3"></option>
                            <option value="4"></option>
                            <option value="5"></option>
                            <option value="6"></option>
                        </select>
                        <select
                            class="ql-color ql-focusable quill-tooltip"
                            [attr.data-tooltip]="'Text color' | translate"
                            [attr.aria-label]="'Text color' | translate"
                            tabindex="-1"></select>
                        <select
                            class="ql-background ql-focusable me-3 quill-tooltip"
                            [attr.data-tooltip]="'Background color' | translate"
                            [attr.aria-label]="'Background color' | translate"
                            tabindex="-1"></select>
                        <select
                            class="ql-align ql-focusable me-3 quill-tooltip"
                            [attr.data-tooltip]="'Alignment' | translate"
                            [attr.aria-label]="'Alignment' | translate"
                            tabindex="-1"></select>
                        <button
                            class="ql-clean ql-focusable"
                            type="button"
                            tooltip="{{ 'Clean formatting' | translate }}"
                            container="body"
                            [attr.aria-label]="'Clean formatting' | translate"
                            tabindex="-1"></button>
                        <button
                            class="ql-blockquote ql-focusable me-3"
                            type="button"
                            tooltip="{{ 'Blockquote' | translate }}"
                            container="body"
                            [attr.aria-label]="'Blockquote' | translate"
                            tabindex="-1"></button>
                        <button
                            class="ql-link ql-focusable"
                            type="button"
                            tooltip="{{ 'Link' | translate }}"
                            container="body"
                            [attr.aria-label]="'Link' | translate"
                            tabindex="-1"></button>
                        <button
                            class="ql-image ql-focusable"
                            type="button"
                            tooltip="{{ 'Image' | translate }}"
                            container="body"
                            [attr.aria-label]="'Image' | translate"
                            tabindex="-1"></button>
                        <!--            <span class="ql-format-separator"></span>-->
                        <!--            <button class="ql-code-block"></button>-->
                        <!--            <button class="ql-indent" value="-1"></button>-->
                        <!--            <button class="ql-indent" value="+1"></button>-->
                        <!--            <button class="ql-direction" value="rtl"></button>-->
                    </div>
                }
            </quill-editor>

            @if (isLocalStorageSupported) {
                <sb-quill-emoji-picker
                    [buttonId]="'btn-emoji'"
                    [containerClass]="'smiley-popover'"
                    (updateQuillSelection)="updateQuillSelection(quillEditor)"
                    (emojiSelect)="
                        replyTemplateManagerService.chooseReplyTemplate({
                            $event: $event.$event,
                            templateText: $event.emoji,
                            quillEditor,
                            quillRange,
                            isSmile: true,
                        })
                    ">
                </sb-quill-emoji-picker>
            }
        </div>
        <div class="buttons-panel">
            @if (isWithReplyTemplates) {
                <button
                    (click)="openReplyTemplatesModal($event, quillEditor)"
                    class="btn btn-icon float-end"
                    type="button"
                    [attr.aria-label]="'Reply templates' | translate"
                    tooltip="{{ 'Insert a saved template' | translate }}"
                    container="body">
                    <sb-inline-svg class="icon" [url]="'/assets/images/Copy icon.svg'"></sb-inline-svg>
                </button>
            }
            @if (isWithSignature) {
                <button
                    [disabled]="!isSignatureLoaded || !commonDataService.signatures?.socialBoards"
                    [attr.aria-label]="'Signature' | translate"
                    (click)="setSignature($event, false)"
                    class="btn btn-icon float-end"
                    id="btn-signature"
                    type="button"
                    tooltip="{{ 'Signature' | translate }}"
                    container="body">
                    <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Pen icon.svg'">
                    </sb-inline-svg>
                </button>
            }
            <ng-container *ngTemplateOutlet="attachmentsBlockTemplate"></ng-container>
        </div>
        <div
            class="clearfix"
            [hidden]="
                !(isWithReplyTemplates || isInternalForm) ||
                (formService.isSubmitted && isQuillEmpty && formField.isRequired)
            "></div>

        @if (formService.isSubmitted && isQuillEmpty && formField.isRequired) {
            <div class="text-danger clearfix" translate>Please fill this field</div>
        }
    </div>
}
